// @ts-nocheck
import { apiRequest } from "../../services/apiService";
import {
  EDIT_MULTIPLE_POSITIONS_FAIL,
  EDIT_MULTIPLE_POSITIONS_LOADING,
  EDIT_MULTIPLE_POSITIONS_SUCCESS
} from "../constants/createEvent";
import { addEditLogAction, addLogAction } from "./logs";

const updateMultiplePositionsAction = ({
  eventInfo,
  params,
  // sessionId,
  payload,
  editLogPayload,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback
}) => {
  return async (dispatch, getState) => {
    if (beforeCallback) {
      beforeCallback();
    }

    dispatch({ type: EDIT_MULTIPLE_POSITIONS_LOADING });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `updateMultiplePositions`,
      data: payload,
      params,
      isToken: Boolean(getState()?.auth?.userToken),
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      // dispatch({
      //   type: UPDATE_SESSION_POSITION_SUCCESS,
      //   payload: response.data
      // });

      dispatch({
        type: EDIT_MULTIPLE_POSITIONS_SUCCESS
      });

      if (getState()?.auth?.userToken) {
        dispatch(
          addEditLogAction({
            id: eventInfo?._id,
            payload: {
              actionById: getState()?.auth?.userId,
              ...editLogPayload
            }
          })
        );
      }

      if (successCallback) {
        successCallback();
      }
    } else if (error) {
      dispatch({ type: EDIT_MULTIPLE_POSITIONS_FAIL });
      if (failureCallback) {
        failureCallback({
          error
        });
      }
    }
  };
};

const updateMultiplePositionsOfMultipleSessionsAction = ({
  eventInfo,
  params,
  // sessionId,
  payload,
  editLogPayload,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback
}) => {
  return async (dispatch, getState) => {
    if (beforeCallback) {
      beforeCallback();
    }

    // dispatch({ type: EDIT_MULTIPLE_POSITIONS_LOADING });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `updateMulSessionMulPositions`,
      data: payload,
      params,
      isToken: Boolean(getState()?.auth?.userToken),
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      // dispatch({
      //   type: UPDATE_SESSION_POSITION_SUCCESS,
      //   payload: response.data
      // });

      // dispatch({
      //   type: EDIT_MULTIPLE_POSITIONS_SUCCESS
      // });

      if (getState()?.auth?.userToken && editLogPayload) {
        dispatch(
          addEditLogAction({
            id: eventInfo?._id,
            payload: {
              actionById: getState()?.auth?.userId,
              ...editLogPayload
            }
          })
        );
      }

      if (successCallback) {
        successCallback({
          response
        });
      }
    } else if (error) {
      // dispatch({ type: EDIT_MULTIPLE_POSITIONS_FAIL });
      if (failureCallback) {
        failureCallback({
          error
        });
      }
    }
  };
};

const addMultiplePositionsOfMultipleSessionsAction = ({
  eventInfo,
  params,
  // sessionId,
  payload,
  addLogPayload,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback
}) => {
  return async (dispatch, getState) => {
    if (beforeCallback) {
      beforeCallback();
    }

    // dispatch({ type: EDIT_MULTIPLE_POSITIONS_LOADING });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `addMultipleSessionMultiplePositions`,
      data: payload,
      params,
      isToken: Boolean(getState()?.auth?.userToken),
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      if (getState()?.auth?.userToken) {
        dispatch(
          addLogAction({
            id: eventInfo?._id,
            payload: {
              actionById: getState()?.auth?.userId,
              ...addLogPayload
            }
          })
        );
      }

      if (successCallback) {
        successCallback({
          response
        });
      }
    } else if (error) {
      // dispatch({ type: EDIT_MULTIPLE_POSITIONS_FAIL });
      if (failureCallback) {
        failureCallback({
          error
        });
      }
    }
  };
};

const fetchCoordinatorsContractorsAndClientsAction = ({
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback,
  params
}) => {
  return async (dispatch, getState) => {
    try {
      if (beforeCallback) {
        beforeCallback();
      }

      const results = await Promise.all([
        apiRequest({
          method: "GET",
          // url: `getAllCoordinators?page=${payload?.page}`,
          url: `getAllCoordinators`,
          data: null,
          params,
          isToken: true
        }),
        apiRequest({
          method: "GET",
          url: `getAllContractors`,
          data: null,
          params,
          // version: "v3",
          isToken: true
        }),
        apiRequest({
          method: "GET",
          // url: `getAllClients?page=${payload?.page}`,
          url: `getAllClients`,
          data: null,
          params,
          isToken: true
        })
      ]);

      if (afterCallback) {
        afterCallback();
      }

      for (let i = 0; i < results?.length; i++) {
        if (results?.[i]?.error) {
          if (failureCallback) {
            failureCallback({
              error: results?.[i]?.error
            });
          }
        }
      }

      if (successCallback) {
        successCallback({
          response: {
            coordinators: results?.[0]?.response,
            contractors: results?.[1]?.response,
            clients: results?.[2]?.response
          }
        });
      }
    } catch (err) {}
  };
};

export {
  updateMultiplePositionsAction,
  updateMultiplePositionsOfMultipleSessionsAction,
  addMultiplePositionsOfMultipleSessionsAction,
  fetchCoordinatorsContractorsAndClientsAction
};